;(function() {
  'use strict'

  Controller.$inject = ["$state", "glError", "channelService"];
  angular.module('app.channel').controller('Channel', Controller)

  /* @ngInject */
  function Controller($state, glError, channelService) {
    var ctrl = this

    ctrl.$onInit = onInit

    function onInit() {
      // We grab the params immediately because I think angular
      // strips out params if the route definition doesn't
      // specify them.
      var params = new URL(window.location.href).searchParams

      ctrl.channelId = $state.params.channelId
      ctrl.linkId = $state.params.linkId
      ctrl.readOnly = $state.params.readOnly
      loadChannel()
        .then(function() {
          if (!ctrl.channel.enabled) {
            return glError.notFound({ route: glError.Routes.DEFAULT })
          }

          // Redirect to the survey but forward all params along.
          // We can't use $state.go() because some params are dynamic
          // and UIRouter doesn't support this (they get removed).
          params.set('channelId', ctrl.channelId)
          var paramsStr = params.toString()
          if (paramsStr) paramsStr = '?' + paramsStr
          window.history.pushState(
            null,
            '',
            '/survey/' + ctrl.channel.survey.id + paramsStr
          )
        })
        .catch(glError.fromStatus)
    }

    function loadChannel() {
      return channelService.get(ctrl.channelId).then(function(channel) {
        ctrl.channel = channel
      })
    }
  }
})()
